// src/routes/AuthRoutes.js
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Register from "../pages/Auth/Register";
import Login from "../pages/Auth/Login";
// import Home from "../pages/Home";
// import MarketPlace from "pages/Home/MarketPlace";
// import PackagesContact from "pages/Home/PackagesContact";

const ScrollToTopOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]); // ทำงานเมื่อ URL เปลี่ยนแปลง

  return null;
};

const AuthRoutes = () => {
  return (
    <>
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
        {/* <Route path="/home" element={<Home />} />
        <Route path="/marketplace" element={<MarketPlace />} />
        <Route path="/contact" element={<PackagesContact />} /> */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

export default AuthRoutes;
